import request from '@/utils/request';
import qs from "qs";

const path = 'api/v1';

const deviceAdd = (data) => request({
  url: `${path}/devices`,
  method: 'post',
  data
});

const deviceUpdate = (data) => request({
  url: `${path}/devices`,
  method: 'put',
  data
});

const deviceDelete = (data) => request({
  url: `${path}/devices`,
  method: 'delete',
  data
});

const devicesList = (data) => request({
  url: `${path}/devices`,
  method: 'get',
  params: data,
  paramsSerializer: params => {
    return qs.stringify(params, { indices: false });
  }
});

const deviceHistory = (data) => request({
  url: `${path}/device/history`,
  method: 'get',
  params: data
});

const deviceDeliveryAdd = (data) => request({
  url: `${path}/device/delivery`,
  method: 'post',
  data
});

const deviceDeliveryUpdate = (data) => request({
  url: `${path}/device/delivery`,
  method: 'put',
  data
});

const deviceDeliveryDelete = (data) => request({
  url: `${path}/device/delivery`,
  method: 'delete',
  data
});

const deviceDeliveryList = (data) => request({
  url: `${path}/device/delivery`,
  method: 'get',
  params: data,
  paramsSerializer: params => {
    return qs.stringify(params, { indices: false });
  }
});

export {
  deviceAdd,
  deviceUpdate,
  deviceDelete,
  devicesList,
  deviceHistory,
  deviceDeliveryAdd,
  deviceDeliveryUpdate,
  deviceDeliveryDelete,
  deviceDeliveryList,
}
